import { data } from '../../svg/Logout/data';
import { makeIcon } from '../makeIcon';

export const Logout = makeIcon(data, 'logout', 'Logout');

export default Logout;
